/* Modal forms. */
.dialog {
  width: min(520px, calc(100vw - 32px));
  padding: 0;
  border: var(--dimension-line-hairline) solid var(--color-border-control);
  border-top: var(--dimension-line-accent) solid var(--color-surface-signal);
  background: var(--color-surface-base);
  color: var(--color-text-primary);
}
.dialog::backdrop {
  background: color-mix(in srgb, var(--color-surface-inverse) 45%, transparent);
}
.dialog form {
  display: grid;
  gap: var(--dimension-space-3);
  padding: var(--dimension-space-5);
}
.dialogTitle {
  margin: 0;
}
.field {
  display: grid;
  gap: var(--dimension-space-1);
  flex: 1;
}
.muted {
  color: var(--color-text-secondary);
}
.input {
  height: 40px;
  padding: 0 var(--dimension-space-2);
  color: var(--color-text-primary);
  background: var(--color-surface-raised);
  border: var(--dimension-line-hairline) solid var(--color-border-control);
}
:where(.input) {
  font: inherit;
}
.pair {
  display: flex;
  gap: var(--dimension-space-3);
}
.check input {
  accent-color: var(--color-text-primary);
}
.check {
  display: flex;
  align-items: center;
  gap: var(--dimension-space-2);
}
.actions {
  display: flex;
  gap: var(--dimension-space-2);
  margin-top: var(--dimension-space-2);
}
.spacer {
  flex: 1;
}
